import '../../Pages/Client/Cvtheque/CvTheque.scss';

import { Add } from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';
import { AppBar, Button, Dialog, FormControl, IconButton, Toolbar } from '@mui/material';
//import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { dureeBdcEnum } from '../../data/Interfaces';
import useFormValidation, { champRequisString } from '../../hooks/useFormValidation';
import usePostRequest from '../../hooks/usePostRequest';
import useRole from '../../hooks/useRole';
import useUtilities from '../../hooks/useUtilities';
import useWindowSize from '../../hooks/useWindowSize';
import { calculateWorkingDaysBetweenDates } from '../../Utils/utils';
import { buttonStyles,buttonStylesGreen } from '../docsAdministrative/JsObjectStyles';
import RegimeModeTravail from '../shared/RegimeModeTravail';
import { DatePickerComponent, IconTextField, SelectComponent, TextFieldComponent, Transition } from '../shared/ReusableSmallComponents';
import SearchCity from '../shared/SearchCity';

function DialogModifierDossier({selectedDossier, openClasser, handleCloseClasser }) {
    DialogModifierDossier.propTypes = {
        selectedDossier: PropTypes.any,
        openClasser: PropTypes.any,
        handleCloseClasser: PropTypes.func,
    };
    //! hooks rule : call a hook only inside a functionnal component, don't try to create a function to prevent DRY ..
    const role = useRole();
    const { setShowErrors, setErrors, errors } = useUtilities();
    const { postData } = usePostRequest();
    const [dossierId, setDossierId] = useState('');
    const [dossierName, setDossierName] = useState('');
    const {device}=useWindowSize();
    const { i18n } = useTranslation();
    const [modeTravail, setModeTravail] = React.useState({
        type: '',
        nbJrsRemotePerWeek: '',
    });
    const [regimeTravail, setRegimeTravail] = React.useState({
        type: '',
        nbJrsPartielPerWeek: '',
    });
    const [localisation, setLocalisation] = useState();
    const [tjMax, setTjMax] = useState(0);
    const [dateDebutMission, setDateDebutMission] = useState(null);
    const [dateFinMission, setDateFinMission] = useState(null);
    const [dureeMission, setDureeMission] = useState(0);
    const [dureeBDC, setDureeBDC] = useState();
    const [isValid] = useFormValidation([
        { name: 'dossierName', value: dossierName },
    ]);
    useEffect(() => {
        if (selectedDossier) {
            initializeDossier(selectedDossier);
        }
    }, []);
    useEffect(() => {
        if (dateDebutMission !== null && dateFinMission !== null) {
            setDureeMission(calculateWorkingDaysBetweenDates(dateDebutMission, dateFinMission, regimeTravail.nbJrsPartielPerWeek));
        }
    }, [dateDebutMission, dateFinMission, regimeTravail.nbJrsPartielPerWeek]);

    const updateDossier = async () => {
        try {
            postData({
                url: '/cvTheque/updateDossier', payload: {
                    dossierId,
                    nom: dossierName,
                    localisation, tjMax, dateDebutMission,
                    dateFinMission, dureeMission, dureeBDC,
                    modeTravail, regimeTravail
                }
            });
            resetDataAndClose();
        } catch (error) {
            console.log(error.response?.status, error.response?.data.error);
        }
    };
    const scroll='paper';
    const initializeDossier = (selectedDossier) => {
        setDossierId(selectedDossier?._id);
        setDossierName(selectedDossier?.nomDossier);
        setModeTravail(selectedDossier?.modeTravail);
        setRegimeTravail(selectedDossier?.regimeTravail);
        setLocalisation(selectedDossier?.localisation);
        setTjMax(selectedDossier?.tjMax);
        setDateDebutMission(selectedDossier?.dateDebutMission);
        setDateFinMission(selectedDossier?.dateFinMission);
        setDureeMission(selectedDossier?.dureeBDC);
        setDureeBDC(selectedDossier?.dureeBDC);
    };
    const resetDataAndClose = () => {
        setDossierId('');
        setDossierName('');
        setModeTravail({
            type: '',
            nbJrsRemotePerWeek: '',
        });
        setLocalisation();
        setRegimeTravail({
            type: '',
            nbJrsPartielPerWeek: '',
        });
        setTjMax(0);
        setDateDebutMission(null);
        setDateFinMission(null);
        setDureeMission(0);
        setDureeBDC();
        handleCloseClasser();
    };
    return (
        <Dialog
            fullScreen
            open={openClasser}
            TransitionComponent={Transition}
            onClose={resetDataAndClose}
            scroll={scroll}
            PaperProps={{
                style: {
                    background: '#F5F6FA',
                },
            }}
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
        >
            <AppBar>
                <Toolbar>
                    <IconButton
                        edge="start"
                        color="inherit"
                        onClick={resetDataAndClose}
                        aria-label="close"
                    >
                        <CloseIcon />
                    </IconButton>
                </Toolbar>
            </AppBar>
            <form style={{display:'flex',background: '#F5F6FA',paddingTop: device=='desktop'?'150px':'100px',justifyContent:'center',width:'100%'}}>
                <div className='frame14Modified4ClasserCvTheque'>
                    <h4
                        className='titlesociete'
                        style={{width: device=='desktop'?'700px':'auto'}}
                    >{i18n.t('Modifier le dossier')} - {selectedDossier?.dossierId} -</h4>
                    <FormControl style={{display:'flex',gap:'12px',alignSelf:'stretch'}}>
                        <div style={{display:'flex',flexDirection:'column',gap:'8px',width:'100%'}}>
                            <h6 className='nomPrenomProfile'>{i18n.t('Informations du dossier')}</h6>
                            <IconTextField
                                //id="outlined-name"
                                //label="Nom"
                                placeholder={i18n.t('Entrer le Nom du dossier')}
                                style={{width:'100%', borderRadius:'8px',background:'white'}}
                                sx={{
                                    '& > :not(style)': { borderRadius:'8px' },
                                }}
                                iconEnd={<Add />}
                                //InputProps={{
                                //    endAdornment: (
                                //        <div className='iconStyleStartAdornment iconStyleEndAdornment'>
                                //            <InputAdornment position="end">
                                //                <Add />
                                //            </InputAdornment>
                                //        </div>
                                //    ),
                                //}}
                                name='dossierName'
                                disabled={role=='admin'}
                                value={dossierName}
                                onChange={(e) => setDossierName(e.target.value)}
                                autoComplete='off'
                                //endIcon={<AddIcon />}
                            />
                            <h6 className='nomPrenomProfile'>{i18n.t('Informations supplémentaires')}</h6>
                            <RegimeModeTravail
                                setModeTravail={setModeTravail}
                                setRegimeTravail={setRegimeTravail}
                                modeTravail={modeTravail}
                                regimeTravail={regimeTravail}
                            />
                            <div className='Frame101292323112'>
                                <p  className='IntitulePoste'>{i18n.t('Localisation')} </p>
                                <SearchCity
                                    // style={{
                                    //     position: 'relative',
                                    //     top: '-18px'
                                    // }}
                                    width='100%'
                                    setCity={setLocalisation}
                                    city={localisation}
                                />
                            </div>
                            <div className='Frame101292323112'>
                                <p  className='IntitulePoste'>{i18n.t('Budget maximum/jour (en €)')}</p>
                                <TextFieldComponent
                                    style={{width:'100%',borderRadius:'8px',background:'white'}}
                                    sx={{
                                        '& > :not(style)': {
                                            borderRadius: '8px',
                                        },
                                    }}
                                    type="number"
                                    min="0"
                                    name="tj"
                                    placeholder={i18n.t('Entrer le Taux journalier')}
                                    autoComplete="off"
                                    value={tjMax}
                                    onChange={(e) => setTjMax(e.target.value)}
                                />
                            </div>
                            <div className='Frame101292323112'>
                                <p  className='IntitulePoste'>{i18n.t('Date de début (mission)')}</p>
                                <DatePickerComponent
                                    label=""
                                    date={dateDebutMission}
                                    setDate={(newValue) => {
                                        setDateDebutMission(newValue);
                                    }}
                                    width={'100%'}
                                    disablePast
                                />
                            </div>
                            <div className='Frame101292323112'>
                                <p  className='IntitulePoste'>{i18n.t('Date estimée de fin (mission)')}</p>
                                <DatePickerComponent
                                    label=""
                                    date={dateFinMission}
                                    setDate={(newValue) => {
                                        setDateFinMission(newValue);
                                    }}
                                    width={'100%'}
                                    disablePast
                                />
                            </div>
                            <div className='Frame101292323112'>
                                <p  className='IntitulePoste'>{i18n.t('Durée de mission')}</p>
                                <TextFieldComponent
                                    style={{ borderRadius:'8px',background:'white',width:'100%'}}
                                    sx={{
                                        '& > :not(style)': {borderRadius: '8px' },
                                    }}
                                    type="number"
                                    name="dureeMission"
                                    value={dureeMission}
                                    // readOnly
                                    //autoComplete="off"
                                    //min="0"
                                    onChange={(e) => setDureeMission(e.target.value)}
                                />
                            </div>
                            <div className='Frame101292323112'>
                                <p  className='IntitulePoste'>{i18n.t('Durée du BDC')}</p>
                                <SelectComponent
                                    val={dureeBDC}
                                    setVal={ (e) => setDureeBDC(e.target.value)}
                                    listVal={dureeBdcEnum}
                                />
                            </div>
                        </div>
                        <div style={{display:'flex',alignSelf:'stretch',justifyContent:'flex-end',flexDirection:device=='desktop'?'row':'column',gap:'8px'}}>
                            <Button
                                variant='text'
                                style={{...buttonStyles(false),...{width: device=='desktop'?'118px':'100%' }}}
                                onClick={resetDataAndClose}
                            >{i18n.t('Annuler')}</Button>
                            <Button
                                variant='contained'
                                style={{...buttonStylesGreen(false),...{width:device=='desktop'?'111px':'100%'}}}
                                type='submit'
                                onClick={(e) => {
                                    e.preventDefault();
                                    if (regimeTravail.type == 'temps-partiel') {
                                        if (isNaN(parseFloat(regimeTravail.nbJrsPartielPerWeek))){
                                            setErrors({...errors, ...{nbJrsPartielPerWeek: champRequisString}});
                                            setShowErrors(true);
                                        }
                                    }
                                    else if (isValid) {
                                        updateDossier();
                                        resetDataAndClose();
                                        setShowErrors(false);
                                        setErrors({});
                                    }
                                    else {
                                        setErrors({...errors, ...{nbJrsPartielPerWeek: ''}});
                                        setShowErrors(true);
                                    }
                                }}
                            >
                                {i18n.t('Enregistrer')}
                            </Button>
                        </div>
                    </FormControl>
                </div>
            </form>
        </Dialog>
    );
}

export default DialogModifierDossier;
